// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___8bhey","bodyMargin":"bodyMargin___2Y_Jv","links":"links___1fdcs","submit":"submit___BoKax","modalTerms":"modalTerms___22oWq"};